var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHamburger = function SvgIconHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Z",
    fill: "#fff"
  })));
};
export { SvgIconHamburger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgOEMwIDcuNDQ3NzIgMC40NDc3MTUgNyAxIDdIMjNDMjMuNTUyMyA3IDI0IDcuNDQ3NzIgMjQgOEMyNCA4LjU1MjI4IDIzLjU1MjMgOSAyMyA5SDFDMC40NDc3MTUgOSAwIDguNTUyMjggMCA4Wk0wIDE2QzAgMTUuNDQ3NyAwLjQ0NzcxNSAxNSAxIDE1SDIzQzIzLjU1MjMgMTUgMjQgMTUuNDQ3NyAyNCAxNkMyNCAxNi41NTIzIDIzLjU1MjMgMTcgMjMgMTdIMUMwLjQ0NzcxNSAxNyAwIDE2LjU1MjMgMCAxNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";